export default "__VITE_ASSET__CV_$Mi8J__"